export default "__VITE_ASSET__Bx6eZ7aS__"